import { style, animate, animation } from '@angular/animations';

export const fadeInAnimation = animation([
  style({ opacity: '0' }),
  animate('1s ease-out', style({ opacity: '1' })),
]);
